/*
  THAANI — Sticky Add-to-Cart-Leiste (mobil)

  Die Leiste blendet sich ein, sobald der Haupt-Kaufbutton nach oben aus dem
  Viewport gescrollt ist, und wieder aus, sobald er zurueck im Bild ist.
  Der Button in der Leiste haengt ueber das form-Attribut am regulaeren
  Produktformular — es braucht also kein eigenes Cart-JS.

  Zusaetzlich wird der Preis in der Leiste bei einem Variantenwechsel
  nachgezogen (Dawn-Event PUB_SUB_EVENTS.variantChange).
*/

class ThaaniStickyAtc extends HTMLElement {
  connectedCallback() {
    this.anchor = this.dataset.target ? document.querySelector(this.dataset.target) : null;

    if (this.anchor && typeof IntersectionObserver !== 'undefined') {
      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            const scrolledPast = entry.boundingClientRect.top < 0;
            this.classList.toggle('is-visible', !entry.isIntersecting && scrolledPast);
          });
        },
        { threshold: 0 }
      );

      this.observer.observe(this.anchor);
    }

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
        this.updatePrice(event);
      });
    }
  }

  disconnectedCallback() {
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }

    if (this.variantChangeUnsubscriber) {
      this.variantChangeUnsubscriber();
      this.variantChangeUnsubscriber = null;
    }
  }

  updatePrice(event) {
    const data = event && event.data;
    if (!data || !data.html || String(data.sectionId) !== this.dataset.sectionId) return;

    const target = this.querySelector('.thaani-sticky-atc__price');
    const source = data.html.getElementById(`price-${data.sectionId}`);
    if (!target || !source) return;

    const priceRoot = source.querySelector('.price') || source;
    const onSale = priceRoot.classList && priceRoot.classList.contains('price--on-sale');
    const selector = onSale ? '.price__sale .price-item--sale' : '.price__regular .price-item--regular';
    const item = priceRoot.querySelector(selector) || priceRoot.querySelector('.price-item');

    if (item) target.textContent = item.textContent.trim();
  }
}

if (!customElements.get('thaani-sticky-atc')) {
  customElements.define('thaani-sticky-atc', ThaaniStickyAtc);
}
